"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIconWrapper = exports.StyledIcon500px = exports.ArrowBox = exports.ArrowWrapperBox = exports.StyledSocialContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("../../../StyledLayout");

var _MediaQueries = _interopRequireDefault(require("../../../MediaQueries"));

var _constants = require("../../constants/constants");

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledSocialContainer = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledSocialContainer",
  componentId: "sc-1o8a45f-0"
})(["div:last-child{margin-right:0 !important;}"]);
exports.StyledSocialContainer = StyledSocialContainer;
var ArrowWrapperBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__ArrowWrapperBox",
  componentId: "sc-1o8a45f-1"
})(["position:absolute;height:48px !important;top:50%;margin-top:-24px;left:24px;right:unset;z-index:3;", ";", " &:hover{svg{path{fill:", " !important;}}p{color:", ";}}"], function (props) {
  return props.direction === 'right' && (0, _styledComponents.css)(["left:unset;right:24px;"]);
}, _MediaQueries["default"].minWidth.xSmall(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    left: ", ";\n\n    ", ";\n  "])), function (props) {
  return "".concat(props.offset, "px");
}, function (props) {
  return props.direction === 'right' && (0, _styledComponents.css)(["left:unset;right:", "px;"], props.offset);
}), function (props) {
  return props.theme[props.colour];
}, function (props) {
  return props.theme[props.colour];
});
exports.ArrowWrapperBox = ArrowWrapperBox;
var ArrowBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__ArrowBox",
  componentId: "sc-1o8a45f-2"
})(["width:48px !important;height:48px !important;border-radius:50% !important;background:rgba(255,255,255,0.5) !important;display:flex !important;align-items:center !important;justify-content:center !important;cursor:pointer;", ";svg{path{fill:", "}}"], function (props) {
  return props.transparentBg && (0, _styledComponents.css)(["background:transparent !important;"]);
}, function (props) {
  return props.theme.portfolioForeground1;
});
exports.ArrowBox = ArrowBox;
var StyledIcon500px = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledIcon500px",
  componentId: "sc-1o8a45f-3"
})(["width:48px !important;svg{width:48px !important;path{fill:", ";}}svg{&:hover{path{fill:", ";}}}"], function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme[_constants.PORTFOLIO_THEME_COLOR[props.fontColor]];
});
exports.StyledIcon500px = StyledIcon500px;
var StyledIconWrapper = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledIconWrapper",
  componentId: "sc-1o8a45f-4"
})(["svg{&:hover{path{fill:", ";}}}"], function (props) {
  return props.theme[_constants.PORTFOLIO_THEME_COLOR[props.fontColor]];
});
exports.StyledIconWrapper = StyledIconWrapper;